<app-bottom-sheet
  [(isOpen)]="isOpen"
  (isOpenChange)="isOpenChange.emit($event)"
  [contentTemplate]="skipContent"
  [headerTemplate]="skipHeader"
  [hasFooter]="false"
  [isFullScreen]="true"
  [preventOverlayClose]="true"
  data-testid="bq9-skip-signature-sheet" />

<ng-template #skipHeader>
  <div class="sheet-header" data-testid="bq9-skip-sheet-header">
    <p class="sheet-title">Skip Customer Signature</p>
  </div>
</ng-template>

<ng-template #skipContent>
  <form [formGroup]="form" class="skip-form" data-testid="bq9-skip-sheet-form">

    <div class="form-field">
      <label class="field-label" [class.label-invalid]="isInvalid('skipType')">Choose a reason*</label>

      <div class="radio-group">
        <div class="radio-option">
          <p-radiobutton
            formControlName="skipType"
            [value]="SignatureSkipType.RefusedToSign"
            inputId="skip-refused"
            data-testid="bq9-skip-radio-refused"
          />
          <label for="skip-refused">Customer refused to sign</label>
        </div>
        @if (form.get('skipType')?.value === SignatureSkipType.RefusedToSign) {
          <div class="refusal-reason-field">
            <app-form-field label="Reason for refusal"
                            inputId="skip-refusal-reason"
                            [required]="true"
                            [control]="form.controls.refusalReason"
                            [maxLength]="maxSignatureSkipReasonLength"
                            [invalid]="isInvalid('refusalReason')"
                            [errorMessages]="{ required: 'Please explain why the customer declined to sign.' }" >
              <app-textarea inputId="skip-refusal-reason"
                            formControlName="refusalReason"
                            placeholder="Explain briefly why they declined to sign"
                            [rows]="2"
                            [showCount]="false"
                            [maxLength]="maxSignatureSkipReasonLength"
                            [invalid]="isInvalid('refusalReason')"
                            testId="bq9-skip-signature-refusal-reason" />
            </app-form-field>
          </div>
        }
        <div class="radio-option">
          <p-radiobutton
            formControlName="skipType"
            [value]="SignatureSkipType.NotPresent"
            inputId="skip-not-present"
            data-testid="bq9-skip-radio-not-present"
          />
          <label for="skip-not-present">Customer is not here</label>
        </div>
      </div>
      @if (isInvalid('skipType')) {
        <app-input-error data-testid="bq9-skip-sheet-type-error">
          Please select a reason.
        </app-input-error>
      }
    </div>

    <div class="form-field">
      <label
        for="skip-h1-email"
        class="field-label"
        [class.label-invalid]="isInvalid('h1Email')"
      ><span class="verified">Homeowner 1</span></label>
      <input
        id="skip-h1-email"
        pInputText
        type="email"
        formControlName="h1Email"
        placeholder="Enter email address"
        [class.input-invalid]="isInvalid('h1Email')"
        data-testid="bq9-skip-sheet-h1-email"
      />
      @if (isInvalid('h1Email')) {
        <app-input-error data-testid="bq9-skip-sheet-h1-email-error">
          A valid email address is required.
        </app-input-error>
      }
    </div>

    <div class="form-field">
      <label for="skip-h2-email" class="field-label">
        Homeowner 2 <span class="field-label-optional">(optional)</span>
      </label>
      <input
        id="skip-h2-email"
        pInputText
        type="email"
        formControlName="h2Email"
        placeholder="Enter email address"
        [class.input-invalid]="isInvalid('h2Email') && !!form.get('h2Email')?.value?.trim()"
        data-testid="bq9-skip-sheet-h2-email"
      />
      @if (isInvalid('h2Email') && !!form.get('h2Email')?.value?.trim()) {
        <app-input-error data-testid="bq9-skip-sheet-h2-email-error">
          Please enter a valid email address.
        </app-input-error>
      }
    </div>

    <div class="sheet-actions">
      <p-button
        label="Save &amp; Submit"
        styleClass="bqa-primary-btn p-fullwidth-button"
        (click)="onSave()"
        data-testid="bq9-skip-sheet-btn-save"
      />
      <p-button
        label="Cancel"
        severity="secondary"
        variant="text"
        styleClass="bqa-secondary-btn p-fullwidth-button"
        (click)="onCancel()"
        data-testid="bq9-skip-sheet-btn-cancel"
      />
    </div>

    @if (isSkipMode) {
      <button
        type="button"
        class="undo-btn"
        (click)="onUndoSkip()"
        data-testid="bq9-skip-sheet-btn-undo"
      >
        Undo — Return to signature
      </button>
    }

  </form>
</ng-template>
